// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eO1b","col":"styles_col__3qgKR","actions":"styles_actions__2K6id","conflict":"styles_conflict__3IxwY"};